import { useMutation } from '@tanstack/react-query';
import { API_NOTIFY_BACK_IN_STOCK } from 'lib/constants/routes';
import { z } from 'zod';

export const notificationSchema = z.object({
  email: z.string().email().min(1),
  variant: z.string().min(1),
});

export const notificationFormSchema = z.object({
  email: z.string().email().min(1, {
    message: 'Required',
  }),
});

export type NotificationSchema = z.infer<typeof notificationSchema>;

const createBackInStockNotification = async ({
  email,
  variant,
}: NotificationSchema) => {
  const match = variant.match(/^(?:gid:\/\/shopify\/ProductVariant\/)(\d*)$/);

  if (!match) {
    const error = `Could not extract variant number from variant ID ${variant}`;
    console.error(error);
    throw new Error(error);
  }

  const numericVariantId = match[1];

  const response = await fetch(API_NOTIFY_BACK_IN_STOCK, {
    method: 'post',
    body: JSON.stringify({ email, variant: numericVariantId }),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error('Back in stock notification failed');
  }
};

export const useBackInStockNotification = () =>
  useMutation({ mutationFn: createBackInStockNotification });
